module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/users/form-register/form-register.component.scss
// module id = ./src/app/pages/users/form-register/form-register.component.scss
// module chunks = main